
import React, { Component } from 'react'
import { do_action } from '../../actions'
import {BASE_URL_ADMIN} from '../../data/config';

export default class AdvertVendor extends Component {
    constructor(props) {
        super(props)
        this.state = {
            advert: {},
            loading: true
        }
    }

    componentWillMount() {
        let {ps} = this.props
        ps = ps || 'contractor'
        do_action('get_advert_position', {type: 'vendor', ps})
            .then(data => {

                this.setState({
                    loading: false
                })

                if (data.signal) {
                    let advert = data.data
                    if (advert && advert.setting) {
                        this.setState({
                            advert: advert.setting
                        })
                    }
                }
            })
            .catch(err => console.log(err));
    }
    render() {
        let {advert, loading} = this.state
        if (loading) return ''

        let imageUrl = advert.image ? BASE_URL_ADMIN + advert.image : "/images/adv1.png";
        return (
            // <div className="side-b advert-vendor">
            //     <img src={imageUrl} alt="advertisment" onError={(e)=>{e.target.src="/images/image-error.png"}} style={{width: '100%'}}/>
            //     <a href={advert.link} target="_blank" className="see-more">See more</a>
            // </div>
            <a href={advert.link} target="_blank" className="see-more">
                <div className="side-b advert-vendor">
                    <img src={imageUrl} alt="advertisment" onError={(e)=>{e.target.src="/images/image-error.png"}} style={{width: '100%'}}/>
                    {/* <a href={advert.link} target="_blank" className="see-more">See more</a> */}
                </div>
            </a>
        )
    }
}